import PropTypes from 'prop-types';

const triggerType = PropTypes.oneOf(['hover', 'click', 'focus']);
export const tooltipProps = {
  trigger: PropTypes.oneOfType([triggerType, PropTypes.arrayOf(triggerType)]),
  visible: PropTypes.bool,
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  onVisibleChange: PropTypes.func,
  getTooltipContainer: PropTypes.func,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  title: PropTypes.element.isRequired,
};
